"use client"

import {createContext, useContext} from "react";

export type AuthUser = {
    id: string;
    name: string;
    discordId: string;
    avatarUrl: string;
}

type AuthState = {
    status: "loading" | "authenticated" | "unauthenticated";
    user: AuthUser | null;
    accessToken?: string | null;
    refresh(): void;
}

export const AuthContext = createContext<AuthState | null>(null);

export function useAuth(guaranteed?: false): AuthState | null
export function useAuth(guaranteed: true): AuthState
export function useAuth(guaranteed = false) {
    const context = useContext(AuthContext);
    if (!context && guaranteed) throw new Error("useAuth must be used within AuthProvider");
    return context;
}
